import React from "react";
import "../Footer/Footer.css";


export default function Footer() {
  return (
    <div className="footerStyle">
      <div className="container pb-16 sm:pb-10 md:pb-12">
        <div className="row">
          <div className="col-lg-6 col-md-6 col-12">
            <div className=" md:text-left footerContent">
              <p className="py-2 paragraphFooter">
              AstraZeneca Near East <br />
              Sweifieh, Bldg. 19, Al Haj Mousa Obaidat Street, <br />
              P.O. Box 17788, Zip Code 11195 Amman, Jordan; Tel: <a target="_blank" href="tel:+96265827580" style={{color: "white"}}>+962 6 582 7580</a> <br />
              For any adverse event report, product quality complaint or medical information request <br/> related to AZ products, you can complete the web-based form accessible 24/7 via the <br/>
              URL: <a target="_blank" href="http://contactazmedical.astrazeneca.com" style={{color: "white"}}> http://contactazmedical.astrazeneca.com</a>
              </p>

            </div>
          </div>

          {/* <div className="col-lg-6 col-md-6 col-12">
            <div className="emailInfo logoContent">
              <p className="py-2 paragraphFooter">
                For Medical: medinfo-ne@astrazeneca.com <br />

              </p>
            </div>
          </div> */}

          <hr className="footer-divider" />


        </div>
        <div className="row ">

         <div className=" col-lg-6 col-md-6 col-12">
           <div className="logoContent  py-3 ">
             <a
               className="footerLinks"
               href="https://www.astrazeneca.com/legal-notice-and-terms-of-use.html"
               target="_blank"
               rel="noopener noreferrer"
             >
               Legal Notices
             </a>
             <a
               className="footerLinks"
               href="https://www.azprivacy.astrazeneca.com/middle-east-and-africa/egypt/en/privacy-notices.html"
               target="_blank"
               rel="noopener noreferrer"
             >
               Privacy Notices
             </a>
             <a
               className="footerLinks"
               href="https://storage.googleapis.com/livesod/Astrazeneca/BET-Label.pdf"
               target="_blank"
               rel="noopener noreferrer"
             >
               Prescribing Information
             </a>
           </div>
         </div>
         <div className=" col-lg-6 col-md-6 col-12">
           <div className="  logoContent">
             <p className="poweredBox lg:text-left mt-xl-0 mt-lg-2 mt-0 ">
               {/* Powered by AstraZeneca <br /> SEL-2887-WEB-1024-1026-NE <br /> For Health Care Professionals Only */}
               Powered by AstraZeneca <br /> Z6-6981 Expiry Date: Mar 2028 <br /> for health care professionals only
             </p>
           </div>
         </div>
       </div>
      </div>
    </div>
  );
}


   {/* <div className="col-xl-4 col-lg-6 col-12">
              <div className="row justify-center">
                <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-3 col-sm-4 col-4">
                  <img
                    src={AstraLogo}
                    alt="logo"
                  />
                </div>
                <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-3 col-sm-4 col-4">
                  <img
                    src={zokLogo}
                    alt="logo"
                  />
                </div>
              </div>
            </div> */}